import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Input, Icon, Button } from 'antd';
import Confirm from '../Confirm';

const modalStyles = `
@keyframes pr-bar   { 0%{background-position:0% center} 100%{background-position:200% center} }
@keyframes pr-float { 0%,100%{transform:translateY(0px)} 50%{transform:translateY(-3px)} }
@keyframes pr-glow  { 0%,100%{box-shadow:0 0 0 0 rgba(24,144,255,0.4)} 50%{box-shadow:0 0 0 10px rgba(0,0,0,0)} }
@keyframes modal-pop { from{opacity:0;transform:scale(0.96) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }

/* ── Modal shell ── */
.pr-modal .ant-modal-content { border-radius:14px!important; overflow:hidden!important; box-shadow:0 24px 64px rgba(0,0,0,.16),0 0 0 1px rgba(24,144,255,.1)!important; animation:modal-pop .3s cubic-bezier(.22,1,.36,1) both!important; }
.pr-modal .ant-modal-header  { padding:0!important; border-bottom:none!important; }
.pr-modal .ant-modal-body    { padding:0!important; }
.pr-modal .ant-modal-footer  { border-top:1px solid #f0f5ff!important; padding:12px 20px!important; display:flex; justify-content:flex-end; gap:8px; }
.pr-modal .ant-modal-close   { top:14px!important; right:16px!important; color:rgba(255,255,255,0.8)!important; transition:color .2s,transform .2s!important; }
.pr-modal .ant-modal-close:hover { color:#fff!important; transform:rotate(90deg)!important; }
.pr-modal .ant-modal-close .ant-modal-close-x { width:36px!important; height:36px!important; line-height:36px!important; }

/* ── Gradient header ── */
.pr-header { background:linear-gradient(135deg,#003a8c 0%,#0050b3 35%,#1890ff 70%,#096dd9 100%); padding:18px 22px 16px; display:flex; align-items:center; gap:14px; position:relative; overflow:hidden; }
.pr-header::before { content:''; position:absolute; inset:0; background-image:radial-gradient(rgba(255,255,255,.09) 1px,transparent 1px); background-size:20px 20px; pointer-events:none; }
.pr-header::after  { content:''; position:absolute; bottom:0; left:0; right:0; height:3px; background:linear-gradient(90deg,#13c2c2,#1890ff,#52c41a,#fa8c16,#13c2c2); background-size:300% auto; animation:pr-bar 3s linear infinite; }
.pr-header-icon { width:44px; height:44px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; animation:pr-glow 2.6s ease-in-out infinite, pr-float 3s ease-in-out infinite; }
.pr-header-title { font-size:15px; font-weight:800; color:#fff; letter-spacing:.8px; }
.pr-header-sub   { font-size:11px; color:rgba(255,255,255,.6); letter-spacing:1px; margin-top:2px; }

/* ── Body ── */
.pr-body { padding:20px 22px 24px; }
.pr-label { font-size:11px; font-weight:700; color:#1890ff; letter-spacing:1px; text-transform:uppercase; margin-bottom:8px; display:flex; align-items:center; gap:5px; }

/* ── Textarea override ── */
.pr-modal .ant-input { border-radius:8px!important; border:1.5px solid #d6e8ff!important; font-size:13px!important; font-weight:500!important; color:#262626!important; padding:10px 12px!important; transition:border-color .2s, box-shadow .2s!important; resize:none!important; }
.pr-modal .ant-input:focus, .pr-modal .ant-input:hover { border-color:#1890ff!important; box-shadow:0 0 0 3px rgba(24,144,255,.12)!important; }
.pr-modal .ant-input::placeholder { color:#bfbfbf!important; font-weight:400!important; }

/* ── Footer buttons ── */
.pr-btn-cancel { border-radius:8px!important; height:34px!important; font-size:12px!important; font-weight:700!important; border:1.5px solid #d6e8ff!important; background:#f0f7ff!important; color:#1890ff!important; transition:all .2s!important; }
.pr-btn-cancel:hover { background:#e6f7ff!important; border-color:#1890ff!important; box-shadow:0 4px 12px rgba(24,144,255,.15)!important; }
.pr-btn-save   { border-radius:8px!important; height:34px!important; font-size:12px!important; font-weight:700!important; background:linear-gradient(135deg,#1890ff 0%,#096dd9 100%)!important; border:none!important; box-shadow:0 4px 14px rgba(24,144,255,.35)!important; transition:all .2s!important; }
.pr-btn-save:hover { transform:translateY(-1px)!important; box-shadow:0 6px 20px rgba(24,144,255,.45)!important; }
`;

const PrInformationModal = props => {
  const { visible, data, closeModal, updateRemarks, setLoading } = props;
  const [remarks, setRemarks] = useState(data.remarks);

  const footer = (
    <>
      <Button
        className="pr-btn-cancel"
        icon="close"
        onClick={() => closeModal('remarks')}
      >
        Cancel
      </Button>
      <Button
        className="pr-btn-save"
        icon="save"
        type="primary"
        onClick={() =>
          Confirm(updateRemarks, null, { id: data.id, remarks }, setLoading)
        }
      >
        Save Remarks
      </Button>
    </>
  );

  return (
    <>
      <style>{modalStyles}</style>
      <Modal
        className="pr-modal"
        visible={visible}
        footer={footer}
        style={{ top: 20 }}
        width="40%"
        onCancel={() => closeModal('remarks')}
        title={
          <div className="pr-header">
            <div className="pr-header-icon">
              <Icon type="form" style={{ fontSize: 20, color: '#fff' }} />
            </div>
            <div>
              <div className="pr-header-title">ADD REMARKS</div>
              <div className="pr-header-sub">Purchase Requisition Note</div>
            </div>
          </div>
        }
      >
        <div className="pr-body">
          <div className="pr-label">
            <Icon type="message" style={{ fontSize: 11 }} />
            Remarks
          </div>
          <Input.TextArea
            rows={4}
            placeholder="Input remarks here..."
            value={remarks}
            onChange={e => setRemarks(e.target.value)}
          />
        </div>
      </Modal>
    </>
  );
};

PrInformationModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  closeModal: PropTypes.func.isRequired,
  updateRemarks: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default PrInformationModal;